// Back to Top Button
document.addEventListener('DOMContentLoaded', function () {
  var backToTopButton = document.getElementById('back-to-top');

  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) { // Show the button after scrolling 300px
      backToTopButton.style.display = 'block';
    } else {
      backToTopButton.style.display = 'none'; // Hide it again if scrolled back up
    }
  });

  backToTopButton.addEventListener('click', function (e) {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll smoothly back to top
  });
});
